(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cc-follow-me-dog"] && !Shopify.designMode) return;
  try {
    

// V10 retains the hand-drawn art and section choreography with bottom-only travel exits.
// Keeping the rig independent from the drawing allows later artwork changes.
(() => {
  'use strict';

  if (customElements.get('cc-follow-dog')) {
    return;
  }

  const TAU = Math.PI * 2;

  const clamp = (value, low, high) => {
    return Math.max(low, Math.min(high, value));
  };

  const mix = (a, b, amount) => {
    return a + (b - a) * amount;
  };

  const smooth = amount => {
    const t = clamp(amount, 0, 1);
    return t * t * (3 - 2 * t);
  };

  const point = (x, y) => {
    return { x, y };
  };

  const interpolate = (a, b, amount) => {
    return point(mix(a.x, b.x, amount), mix(a.y, b.y, amount));
  };

  const bezier = (a, b, c, d, amount) => {
    const t = clamp(amount, 0, 1);
    const u = 1 - t;
    return point(
      u * u * u * a.x + 3 * u * u * t * b.x + 3 * u * t * t * c.x + t * t * t * d.x,
      u * u * u * a.y + 3 * u * u * t * b.y + 3 * u * t * t * c.y + t * t * t * d.y
    );
  };

  // Bend a limb naturally using two segments of a fixed length.
  const limb = (hip, foot, upper, lower, direction) => {
    const dx = foot.x - hip.x;
    const dy = foot.y - hip.y;
    const distance = clamp(Math.hypot(dx, dy), 1, upper + lower - .2);
    const angle = Math.atan2(dy, dx);
    const cosine = clamp(
      (upper * upper + distance * distance - lower * lower) / (2 * upper * distance),
      -1,
      1
    );
    const bend = angle + Math.acos(cosine) * direction;
    const knee = point(
      hip.x + Math.cos(bend) * upper,
      hip.y + Math.sin(bend) * upper
    );
    const width=2.1;
    const nx=-dy/(Math.hypot(dx,dy)||1)*width;
    const ny=dx/(Math.hypot(dx,dy)||1)*width;
    const start=point(hip.x+nx,hip.y+ny);
    const jointA=point(knee.x+nx,knee.y+ny);
    const jointB=point(knee.x-nx,knee.y-ny);
    const endA=point(foot.x+nx,foot.y+ny);
    const endB=point(foot.x-nx,foot.y-ny);
    return `M${start.x} ${start.y} Q${jointA.x} ${jointA.y} ${endA.x} ${endA.y} Q${foot.x+7} ${foot.y-1} ${foot.x+8} ${foot.y+3} Q${foot.x+5} ${foot.y+5} ${endB.x} ${endB.y} Q${jointB.x} ${jointB.y} ${hip.x-nx} ${hip.y-ny}`;
  };

  class FollowDog extends HTMLElement {
    connectedCallback() {
      if (this.connected) {
        return;
      }

      if ([...document.querySelectorAll('cc-follow-dog')].find(element=>element!==this && element.connected)) return;
      this.connected = true;
      this.abort = new AbortController();
      this.actor = this.querySelector('.cc-guide-actor');
      this.actorClip = this.querySelector('.cc-guide-actor-clip');
      this.facing = this.querySelector('.cc-guide-facing');
      this.dog = this.querySelector('.cc-guide-dog');
      this.label = this.querySelector('.cc-guide-label');
      this.poof = this.querySelector('.cc-guide-poof');
      this.cloudFrames = [...this.poof.querySelectorAll('[data-cloud-frame]')];
      this.labelNaturalWidth = null;
      this.labelPaths = [...this.label.querySelectorAll('path')].map(path => ({
        path, length: Math.max(1, path.getTotalLength())
      }));
      this.caption = this.querySelector('.cc-guide-action-caption');
      this.rig = this.querySelector('.cc-guide-rig');
      this.head = this.querySelector('.cc-guide-head');
      this.ear = this.querySelector('.cc-guide-ear');
      this.tail = this.querySelector('.cc-guide-tail');
      this.tongue = this.querySelector('.cc-guide-tongue');
      this.hole = this.querySelector('.cc-guide-hole');
      this.water = this.querySelector('.cc-guide-water');
      this.sun = this.querySelector('.cc-guide-sun');
      this.sunRays = this.sun.querySelector('.cc-guide-sun-rays');
      this.heatWaves = this.sun.querySelector('.cc-guide-heat-waves');
      this.dirt = this.querySelector('.cc-guide-dirt');
      this.debug = this.querySelector('.cc-guide-debug');
      this.particles = [...this.querySelectorAll('[data-dirt]')];
      this.legs = {};
      this.drawPaths = [...this.dog.querySelectorAll('path')];

      this.querySelectorAll('[data-leg]').forEach(element => {
        this.legs[element.dataset.leg] = element;
      });

      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.lastPlayed = new WeakMap();
      this.landmarks = [];
      this.inside = new Set();
      this.sequence = null;
      this.pending = null;
      this.gait = 0;
      this.direction = 1;
      this.serial = 0;
      this.lastPoint = null;
      this.frame = null;
      this.bottomWasVisible = false;
      this.introPlayed = false;
      this.backflipDone = false;

      this.stage = this.querySelector('.cc-guide-stage');
      this.startedAt = performance.now();
      this.played = new WeakMap();
      this.lastSceneScan = -Infinity;
      this.sceneDirty = true;
      this.dismissed = false;
      try { this.sceneConfig = JSON.parse(this.querySelector('.cc-guide-scene-config')?.textContent || '[]'); }
      catch { this.sceneConfig = []; }
      this.readSettings();
      this.measure();
      this.bindEvents();
      this.refreshLandmarks();
      this.sceneFrame=requestAnimationFrame(time=>this.updateScenes(time));
    }

    readSettings() {
      const number = (name, fallback, low, high) => {
        const raw = Number(this.dataset[name]);
        return clamp(Number.isFinite(raw) ? raw : fallback, low, high);
      };

      this.settings = {
        delay: number('delay', 1, 1, 5),
        speed: Number(this.dataset.speed) <= 1.5 ? .7 : number('speed', 70, 30, 100) / 100,
        size: number('size', 120, 80, 180),
        mobileSize: number('mobileSize', 80, 50, 110),
        every: number('every', 2, 1, 4),
        pause: number('pause', 10, 4, 20) * 1000,
        cooldown: number('cooldown', 8, 3, 30) * 1000,
        intro: this.dataset.intro !== 'false',
        loop: this.dataset.fullLoop !== 'false',
        finale: this.dataset.finale !== 'false',
        mobile: this.dataset.mobile !== 'false',
        autoColor: false,
        debug: this.dataset.debug === 'true' && Boolean(window.Shopify?.designMode),
        color: this.dataset.color || '#c9ff3d',
        darkColor: this.dataset.darkColor || '#10393a'
      };

      this.debug.hidden = !this.settings.debug;
    }

    bindEvents() {
      const options = {signal: this.abort.signal};
      const resume = () => {
        this.sceneDirty = true;
        if (this.sequence) this.sequence.previousTime = null;
        cancelAnimationFrame(this.sceneFrame);
        this.sceneFrame = requestAnimationFrame(t => this.updateScenes(t));
        if (this.sequence) {
          cancelAnimationFrame(this.frame);
          this.frame = requestAnimationFrame(t => this.tick(t));
        }
      };
      this.motion.addEventListener('change', resume, options);
      document.addEventListener('visibilitychange', resume, options);
      const resize = () => {
        this.measure();
        this.sceneDirty = true;
        if (this.lastPoint) this.lastPoint = this.keepInside(this.lastPoint);
        resume();
      };
      window.addEventListener('resize', resize, options);
      window.visualViewport?.addEventListener('resize', resize, options);
      window.addEventListener('scroll', () => { this.sceneDirty = true; }, {...options, passive:true});
      for (const name of ['load','unload','reorder']) {
        document.addEventListener(`shopify:section:${name}`, () => this.scheduleRefresh(), options);
      }
      document.addEventListener('keydown', event => {
        if (event.key === 'Escape') { this.dismissed=true; this.depart(); }
      }, options);
      this.layoutObserver = new ResizeObserver(() => { this.sceneDirty=true; });
      const main=document.querySelector('#MainContent, main');
      if(main) this.layoutObserver.observe(main);
    }

    scheduleRefresh() {
      clearTimeout(this.refreshTimer);
      this.refreshTimer = setTimeout(() => this.refreshLandmarks(), 160);
    }

    allowed() {
      return !this.motion.matches
        && !document.hidden
        && (this.settings.mobile || innerWidth >= 750);
    }

    modalOpen() {
      const candidates = document.querySelectorAll(
        'dialog[open], [role="dialog"][aria-modal="true"], cart-drawer.active, details[open].menu-opening'
      );
      return [...candidates].some(element => {
        if (!element.getClientRects().length) {
          return false;
        }
        const enclosingDetails = element.closest('details');
        if (enclosingDetails && !enclosingDetails.open) {
          return false;
        }
        let ancestor = element;
        while (ancestor && ancestor !== document.body) {
          const style = getComputedStyle(ancestor);
          if (ancestor.hidden || ancestor.getAttribute('aria-hidden') === 'true'
            || style.visibility === 'hidden' || style.display === 'none'
            || Number(style.opacity) === 0) {
            return false;
          }
          ancestor = ancestor.parentElement;
        }
        return true;
      });
    }

    measure() {
      this.mobile = innerWidth < 750;
      this.width = document.documentElement.clientWidth || innerWidth;
      this.height = window.visualViewport?.height || innerHeight;
      this.size = this.mobile ? this.settings.mobileSize : this.settings.size;
      this.actor.style.width = `${this.size}px`;
      this.labelNaturalWidth = parseFloat(getComputedStyle(this.label).width) || (this.mobile?195:240);
      this.scale = this.size / 180;
      this.safe = {
        left: this.mobile ? 18 : 30,
        right: Math.max(12, this.width - this.size - (this.mobile ? 18 : 30)),
        top: Math.min(this.height * .25, this.headerBottom() + 20),
        bottom: Math.max(90, this.height - this.size - (this.mobile ? 54 : 30))
      };
      this.safe.top = clamp(this.safe.top, 70, Math.max(70, this.safe.bottom - 80));
    }

    headerBottom() {
      const header = document.querySelector('sticky-header, .shopify-section-header, header');
      if (!header) {
        return 60;
      }
      const rect = header.getBoundingClientRect();
      return clamp(rect.bottom, 50, this.height * .22);
    }

    refreshLandmarks() {
      this.observer?.disconnect();
      this.inside.clear();
      const main = document.querySelector('#MainContent, main');
      if (!main) {
        return;
      }

      const sections = [...main.querySelectorAll('.shopify-section')].filter(section => {
        return !section.contains(this) && section.getBoundingClientRect().height > 100;
      });

      const entries = new Map();
      sections.forEach((section, index) => {
        if (index > 0) {
          entries.set(section, {
            type: 'section',
            target: section,
            importance: true,
            action: 'scratch'
          });
        }
      });

      // Recognize educational rows individually inside Dawn's multirow section.
      const rules = [
        { pattern: /overheating|heat moves fast/i, type: 'heat', action: 'rest' },
        { pattern: /bowl shouldn.t need|constant refills/i, type: 'refill', action: 'wag' },
        { pattern: /water shouldn.t.*follow|temperature swings/i, type: 'temperature', action: 'shake' },
        { pattern: /coldcove sizes|sized for|choose.*size/i, type: 'sizes', action: 'stretch' },
        { pattern: /four simple parts|four parts/i, type: 'parts', action: 'look' },
        { pattern: /riser|a little lift|a higher lift|lift.*height/i, type: 'riser', action: 'hop' },
        { pattern: /questions.*answered|frequently asked|^faq$/i, type: 'faq', action: 'scratch' },
        { pattern: /thoughtful hydration for|animals we love|our story/i, type: 'story', action: 'rest' }
      ];

      main.querySelectorAll('h1, h2, h3').forEach(heading => {
        const rule = rules.find(item => item.pattern.test(heading.textContent));
        if (!rule) {
          return;
        }
        const target = heading.closest('.image-with-text, .multirow__row')
          || heading.closest('.shopify-section');
        if (target && !target.contains(this)) {
          entries.set(target, {
            type: rule.type,
            target,
            importance: true,
            action: rule.action
          });
        }
      });

      // These ids are from the supplied homepage; headings remain editable.
      sections.forEach(section => {
        const known = [
          [/coldcove_hero|critters_hero/, 'intro', 'look'],
          [/four_parts/, 'parts', 'look'],
          [/benefits|riser/, 'riser', 'hop'],
          [/faq/, 'faq', 'scratch'],
          [/brand_story/, 'story', 'rest'],
          [/size_showcase/, 'sizes', 'stretch'],
          [/preorder_cta/, 'cta', 'hop']
        ].find(rule => rule[0].test(section.id));
        if (known) {
          entries.set(section, {
            type: known[1],
            target: section,
            importance: true,
            action: known[2]
          });
        }
      });

      main.querySelectorAll('[data-cc-dog-scene]').forEach(target => {
        entries.set(target,{type:target.dataset.ccDogScene,target,importance:true});
      });
      for (const config of this.sceneConfig) {
        if (!config.target) continue;
        try {
          document.querySelectorAll(config.target).forEach(target => {
            if(!target.contains(this)) entries.set(target,{type:config.type,target,importance:true,config});
          });
        } catch { /* Invalid optional selector leaves automatic matching intact. */ }
      }
      const disabled=[...entries.values()].filter(event=>event.type==='off').map(event=>event.target);
      for(const target of [...entries.keys()]) {
        if(disabled.some(parent=>parent===target || parent.contains(target))) entries.delete(target);
      }
      // Remove a multirow container when its child rows have their own scenes.
      for (const target of [...entries.keys()]) {
        if ([...entries.keys()].some(child=>child!==target && target.contains(child))) entries.delete(target);
      }
      if (sections[0] && !entries.has(sections[0]) && !disabled.some(target=>target.contains(sections[0]))) entries.set(sections[0],{type:'intro',target:sections[0],importance:false});
      this.landmarks = [...entries.values()].filter((event,index) => event.type !== 'off' && (event.type !== 'section' || index % this.settings.every === 0));
      this.footer = document.querySelector('footer');
      if(this.footer && this.settings.finale && !this.landmarks.some(e=>e.type==='finale')) this.landmarks.push({type:'finale',target:this.footer,importance:true});
      this.buildResidents();
      this.layoutObserver?.disconnect();
      this.landmarks.forEach(event=>this.layoutObserver?.observe(event.target));
    }

    buildResidents() {
      // Keep the original single drawing. Section discovery never clones or hides it.
      this.scenes=this.landmarks.filter(event=>(event.type!=='intro' || this.settings.intro) && (event.type!=='finale' || this.settings.finale))
        .map(event=>({event,media:this.imageFor(event.target,event.config),area:0}));
      this.sceneDirty=true;
    }

    keepInside(pos) {
      return point(clamp(pos.x,this.safe.left,this.safe.right),clamp(pos.y,this.safe.top,this.safe.bottom));
    }

    sceneSpot(scene) {
      if(scene.event.type==='intro') return this.openingPoint();
      if(scene.media && scene.event.type!=='finale') return this.imagePoint(scene.media,scene.event.config);
      const rect=scene.event.target.getBoundingClientRect();
      return this.keepInside(point(rect.left+rect.width*.65-this.size*.5,
        rect.top+Math.min(rect.height*.55,this.height*.5)-this.size*.35));
    }

    updateScenes(time) {
      if(!this.connected) return;
      const permitted=this.allowed();
      this.stage.style.visibility=permitted?'visible':'hidden';
      if(!permitted) return;
      if(time-this.lastSceneScan>=100 || this.sceneDirty) {
        this.lastSceneScan=time;
        this.sceneDirty=false;
        this.pausedForModal=this.modalOpen();
        this.stage.style.visibility=this.pausedForModal?'hidden':'visible';
        if(!this.pausedForModal) {
          let dominant=null,largest=0;
          for(const scene of this.scenes||[]) {
            const rect=scene.event.target.getBoundingClientRect();
            const overlap=Math.max(0,Math.min(rect.bottom,this.height)-Math.max(rect.top,this.safe.top));
            const visibleWidth=Math.max(0,Math.min(rect.right,this.width)-Math.max(0,rect.left));
            scene.area=overlap*visibleWidth;
            const history=this.played.get(scene.event.target);
            if(history && scene.area===0) history.left=true;
            if(scene.area>largest || scene.area===largest && scene.event.target===this.sequence?.event.target) {
              largest=scene.area;dominant=scene;
            }
          }
          // Preserve the final hole sequence at the actual page bottom even
          // when a short footer occupies less area than the preceding CTA.
          const footer=(this.scenes||[]).find(scene=>scene.event.type==='finale' && scene.area>0);
          if(this.atBottom() && footer) dominant=footer;
          this.candidate=dominant;
          if(this.sequence && !this.sequence.departing) {
            const current=(this.scenes||[]).find(scene=>scene.event.target===this.sequence.event.target);
            const intent=Math.abs(scrollY-this.sequence.scrollOrigin)>=Math.max(60,this.height*.10);
            const changed=dominant && dominant.event.target!==this.sequence.event.target;
            const currentRect=this.sequence.event.target?.getBoundingClientRect();
            const gone=!currentRect || currentRect.bottom<this.safe.top || currentRect.top>=this.height;
            // A small reading adjustment keeps the gesture. A deliberate scroll
            // hands off to the larger visible section with a short running exit.
            if(gone || changed && intent && (dominant.area>(current?.area||0)*1.03 || dominant.event.type==='finale' && this.atBottom())) this.depart();
          }
          if(!this.sequence && !this.dismissed && dominant) {
            const history=this.played.get(dominant.event.target);
            const initialHero=dominant.event.type==='intro' && !history;
            const openingReady=!initialHero || time-this.startedAt>=this.settings.delay*1000;
            if(openingReady && (!history || history.left)) {
              if(history) history.left=false;
              this.activeScene=dominant;
              dominant.media=this.imageFor(dominant.event.target,dominant.event.config);
              this.begin(dominant.event);
            }
          }
        }
      } else if(this.pausedForModal) this.stage.style.visibility='hidden';
      this.sceneFrame=requestAnimationFrame(next=>this.updateScenes(next));
    }

    atBottom() {
      return scrollY+this.height>=document.documentElement.scrollHeight-70;
    }

    depart() {
      if(!this.sequence || this.sequence.departing || this.sequence.stages[this.sequence.index]?.exitDown) return;
      const from=this.keepInside(this.lastPoint || this.sceneSpot(this.activeScene));
      const duration=clamp((this.height+this.size-from.y)/1.0,300,850);
      this.sequence.stages=[{name:'Head down through the bottom',duration,
        from,to:point(from.x,this.height+this.size),pose:'run',exitDown:true,reading:true}];
      this.sequence.index=0;
      this.sequence.elapsed=0;
      this.sequence.previousTime=null;
      this.sequence.departing=true;
      this.water.style.opacity='0';
      this.sun.style.opacity='0';
    }

    checkBottom() { /* Scene visibility owns the footer. */ }
    request(event) { /* Scene visibility owns activation. */ }
    requestNow(event) { /* Scene visibility owns activation. */ }

    parkPoint() {
      return point(this.safe.right, this.safe.bottom);
    }

    imageFor(target, config) {
      if (!target) return null;
      if(config?.image) {
        try {
          const selected=target.querySelector(config.image);
          if(selected && selected.getBoundingClientRect().width>0) return selected;
        } catch { /* Fall back to the largest visible image. */ }
      }
      const media = [...target.querySelectorAll('[data-cc-dog-image], img, video, .image-with-text__media svg')];
      return media.filter(element => {
        const rect = element.getBoundingClientRect();
        return rect.width > 90 && rect.height > 90;
      }).sort((a,b) => {
        const ar = a.getBoundingClientRect(), br = b.getBoundingClientRect();
        return br.width*br.height-ar.width*ar.height;
      })[0] || null;
    }

    imagePoint(element, config=this.sequence?.event.config) {
      if (!element?.isConnected) return this.parkPoint();
      const rect=element.getBoundingClientRect();
      const read=(name,fallback) => {
        const attr=parseFloat(element.getAttribute(`data-cc-dog-${name}`));
        return Number.isFinite(attr)?clamp(attr,0,1):Number.isFinite(config?.[name])?clamp(config[name]/100,0,1):fallback;
      };
      return this.keepInside(point(rect.left+rect.width*read('x',.54)-this.size*.78,
        rect.top+rect.height*read('y',.64)-this.size*.48));
    }

    waterPoint(element) {
      if(!element?.isConnected) return this.parkPoint();
      const rect=element.getBoundingClientRect();
      const config=this.sequence?.event.config;
      const section=element.closest('[data-cc-water-x], .image-with-text, .multirow__row, .shopify-section');
      const read=(attr,key,fallback) => {
        const value=parseFloat(element.getAttribute(attr) ?? section?.getAttribute(attr));
        return Number.isFinite(value)?clamp(value,0,1):Number.isFinite(config?.[key])?clamp(config[key]/100,0,1):fallback;
      };
      return this.keepInside(point(rect.left+rect.width*read('data-cc-water-x','waterX',.68)-this.size*.97,
        rect.top+rect.height*read('data-cc-water-y','waterY',.82)-this.size*.43));
    }

    openingPoint() {
      // Anchor below the actual hero edge, not the capped header safe area.
      // This keeps the lettering clear of the white strip above the teal hero.
      const hero = document.querySelector('[id*="__cc_coldcove_hero"]') ||
        document.querySelector('main .shopify-section');
      const rect = hero?.getBoundingClientRect();
      const heroTop = rect && rect.bottom>0 ? Math.max(0,rect.top) : this.headerBottom();
      const top = Math.max(this.safe.top, this.headerBottom()+28, heroTop+(this.mobile?28:36));
      const extra=Math.max(0,(this.labelNaturalWidth-this.size)/2);
      return point(this.safe.right-extra, clamp(top,this.safe.top,this.safe.bottom));
    }

    startPoint() {
      return point(this.safe.left - this.size * 1.2, mix(this.safe.top, this.safe.bottom, .35));
    }

    exitPoint() {
      return point(this.safe.right, this.height + this.size);
    }

    loopPoint(amount, variant) {
      const left = this.safe.left;
      const right = this.safe.right;
      const top = this.safe.top;
      const bottom = this.safe.bottom;
      const center = point((left + right) / 2, (top + bottom) / 2);
      const angle = amount * TAU;
      const radiusX = (right - left) / 2;
      const radiusY = (bottom - top) / 2;
      let x = center.x + Math.cos(angle) * radiusX;
      let y = center.y + Math.sin(angle) * radiusY;
      if (variant === 1) {
        y += Math.sin(amount * TAU * 2) * (this.mobile ? 5 : 12);
      }
      if (variant === 2) {
        x += Math.sin(amount * TAU * 2) * (this.mobile ? 4 : 9);
      }
      return point(x, y);
    }

    addStage(sequence, name, duration, from, to, pose, options = {}) {
      sequence.stages.push({
        name,
        duration,
        from,
        to,
        pose,
        ...options
      });
    }

    begin(event) {
      if (!this.allowed()) {
        return;
      }
      this.measure();
      this.label.style.right = `${-(this.labelNaturalWidth-this.size)/2}px`;
      this.serial += 1;
      const start = this.startPoint();
      const opening = this.openingPoint();
      const loopStart = this.loopPoint(0, 0);
      const rect = event.target?.getBoundingClientRect();
      const park = rect ? point(
        clamp(rect.left+rect.width*.58-this.size*.5, this.safe.left, this.safe.right),
        clamp(rect.top+Math.min(rect.height*.45, this.height*.45)-this.size*.35, this.safe.top, Math.min(this.safe.bottom,this.height*.68))
      ) : this.parkPoint();
      const exit = this.exitPoint();
      const media = event.importance ? this.imageFor(event.target,event.config) : null;
      const imageSpot = media ? this.imagePoint(media,event.config) : null;
      const sequence = {
        event,
        scrollOrigin: scrollY,
        anchorTarget: event.target || document.querySelector('[id*="__cc_coldcove_hero"]') || document.querySelector('main .shopify-section'),
        stages: [],
        index: 0,
        elapsed: 0,
        previousTime: null,
        variant: this.serial % 3,
        media
      };

      if(event.type === 'intro') {
        const sniffSpot=point(clamp(this.width*.25-this.size*.5,this.safe.left,this.safe.right),mix(this.safe.top,this.safe.bottom,.28));
        const rightSpot=point(clamp(this.width*.67-this.size*.5,this.safe.left,this.safe.right),mix(this.safe.top,this.safe.bottom,.75));
        const leftSpot=point(clamp(this.width*.33-this.size*.5,this.safe.left,this.safe.right),mix(this.safe.top,this.safe.bottom,.92));
        const downSpot=point(leftSpot.x,this.height+this.size);
        this.addStage(sequence,'Handwritten Follow me',4000,opening,opening,'stand',{label:true,reading:true});
        this.addStage(sequence,'Dust cloud, pause and reveal',1600,opening,opening,'stand',{draw:true,poof:true,reading:true});
        this.addStage(sequence,'Zig left',1800,opening,sniffSpot,'run');
        this.addStage(sequence,'Sniff sniff',1100,sniffSpot,sniffSpot,'sniff',{reading:true});
        this.addStage(sequence,'Zag right',1800,sniffSpot,rightSpot,'run');
        this.addStage(sequence,'Bark bark',850,rightSpot,rightSpot,'bark',{reading:true});
        this.addStage(sequence,'Down toward the left',1500,rightSpot,leftSpot,'run');
        this.addStage(sequence,'Off the bottom',1000,leftSpot,downSpot,'run',{exitDown:true});
      } else if(event.type === 'finale') {
        this.addStage(sequence, 'Find the spot', 450, park, park, 'look');
        this.addStage(sequence, 'Circle', 1500, park, park, 'run', {circle:true});
        this.addStage(sequence, 'Dig', 1500, park, park, 'dig',{face:1});
        this.addStage(sequence, 'Peer into the hole', 650, park, park, 'peer',{face:1,reading:true});
        this.addStage(sequence, 'Snout-first dive', 1200, park, park, 'dive',{face:1,reading:true});
        this.addStage(sequence, 'Close the hole', 400, park, park, 'hidden');
      } else {
        const type=event.type;
        const imageAction=Boolean(media && ['heat','refill','temperature','parts','sizes','riser','story','cta'].includes(type));
        const spot=imageAction?imageSpot:park;
        const down=point(
          clamp(spot.x+(spot.x>this.width*.5?-1:1)*this.size*.6,this.safe.left,this.safe.right),
          this.height+this.size
        );
        this.addStage(sequence,'Already beside the image',type==='heat'?100:220,spot,spot,type==='story'?'sit':'stand',{fadeIn:true,face:imageAction?1:undefined,imageAnchor:imageAction,reading:true});
        const add=(name,duration,pose,extra={})=>this.addStage(sequence,name,duration,spot,spot,pose,{imageAnchor:imageAction,...extra});
        if(type==='heat') {
          add('Thirsty pant',300,'pant',{imageAnchor:imageAction,reading:true});
          add('Sniff sniff',350,'sniff',{imageAnchor:imageAction,face:imageAction?1:undefined,reading:true});
          add('Step to the bowl',400,'run',{approachWater:true,reading:true});
          add('Nose dip',220,'nose-dip',{waterAnchor:true,reading:true});
          add('Blue water sip',650,'sip',{waterAnchor:true,face:1,reading:true});
          add('Quick lip lick',300,'lip-lick',{waterAnchor:true,reading:true});
          add('Happy after the sip',350,'wag',{waterAnchor:true,reading:true});
        } else if(type==='refill') {
          add('Look toward the water',650,'look-up',{face:1,reading:true});
          add('Quick head tilt',750,'look',{reading:true});
          add('Step to the bowl',400,'run',{approachWater:true,reading:true});
          add('Nose dip',220,'nose-dip',{waterAnchor:true,reading:true});
          add('Blue water sip',650,'sip',{waterAnchor:true,face:1,reading:true});
          add('Quick lip lick',300,'lip-lick',{waterAnchor:true,reading:true});
          add('Happy tail wag',450,'wag',{waterAnchor:true,reading:true});
        } else if(type==='temperature') {
          add('Sniff sniff',600,'sniff');
          add('Shake off',850,'shake');
        } else if(type==='parts') {
          add('Play bow',600,'bow');
          add('Playful pounce',850,'pounce');
        } else if(type==='sizes') {
          add('Look up',550,'look-up');
          add('Stretch tall',950,'stretch');
          add('Settle',450,'stand');
        } else if(type==='riser') {
          add('Crouch',350,'bow');
          add('One backflip',1000,'backflip');
          add('Land and wag',600,'wag');
        } else if(type==='story') {
          add('Already sitting',450,'sit',{reading:true});
          add('You surprised me',300,'startle',{seated:true,reading:true});
          add('Scratch ear once',1100,'scratch',{seated:true,reading:true});
          add('Stand',450,'rise');
        } else if(type==='faq') {
          add('Curious head tilt',700,'look');
          add('Check you are coming',650,'look-back');
        } else if(type==='cta') {
          add('Little hop',650,'hop');
          add('Handwritten Follow me',2600,'stand',{label:true,reading:true});
          add('Dust cloud, pause and reveal',1600,'stand',{draw:true,poof:true,reading:true});
        } else {
          add('Look back',550,'look-back');
          add('Tail wag',650,'wag');
        }
        add('Check you are coming',Math.min(this.settings.pause,650),'look-back',{reading:true});
        const exitDuration=clamp((down.y-spot.y)/.32,1400,2600);
        this.addStage(sequence,'Run through the bottom',exitDuration,spot,down,'run',{leaveImage:imageAction,leaveWater:media && ['heat','refill'].includes(type),exitDown:true});
      }

      if(event.type!=='intro' && event.type!=='finale') {
        const anchor=this.activeScene?this.sceneSpot(this.activeScene):park;
        sequence.stages.forEach(stage=>{
          // Keep real travel stages intact. Anchor only the in-place gestures.
          if(stage.pose!=='run' && !stage.imageAnchor) {
            stage.from=anchor;stage.to=anchor;stage.residentAnchor=true;
          }
        });
      }
      this.sequence = sequence;
      this.lastRenderedPosition = null;
      this.lastPoint = null;
      this.actor.style.opacity = '1';
      this.actorClip.style.clipPath = 'none';
      this.hole.style.opacity = '0';
      this.dirt.style.opacity = '0';
      this.setColor(opening);
      this.frame = requestAnimationFrame(time => this.tick(time));
    }

    addReadingStages(sequence, event, park) {
      const available = this.settings.pause;
      if (event.action === 'hop') {
        this.addStage(sequence, 'A little hop', 850, park, park, 'hop');
      }
      this.addStage(sequence, 'Sit down', 700, park, park, 'sit-down');

      // Reading time is real time; the speed slider slows travel and gait only.
      const gestures = [
        ['look', .30],
        ['scratch', .35],
        ['look', .20],
        ['wag', .15]
      ];

      gestures.forEach(([pose, fraction]) => {
        this.addStage(sequence, `Reading: ${pose}`, available * fraction, park, park, pose, {
          reading: true,
          seated: true
        });
      });
    }

    tick(time) {
      if (!this.sequence || !this.connected) {
        return;
      }
      if (!this.allowed()) {
        this.sequence.previousTime=null;
        return;
      }
      if(this.pausedForModal) {
        this.sequence.previousTime=time;
        this.frame=requestAnimationFrame(next=>this.tick(next));
        return;
      }

      const sequence = this.sequence;
      const previous = sequence.previousTime ?? time;
      const delta = clamp(time - previous, 0, 60);
      sequence.previousTime = time;
      this.frameDelta=delta;
      let stage = sequence.stages[sequence.index];
      sequence.elapsed += delta * (stage.reading ? 1 : this.settings.speed);

      while (sequence.elapsed >= stage.duration) {
        sequence.elapsed -= stage.duration;
        sequence.index += 1;
        if (sequence.index >= sequence.stages.length) {
          this.complete();
          return;
        }
        stage = sequence.stages[sequence.index];
        this.lastPoint=null;
      }

      const progress = clamp(sequence.elapsed / stage.duration, 0, 1);
      if ((stage.imageAnchor || stage.approachImage) && sequence.media) {
        const rect = sequence.media.getBoundingClientRect();
        if (rect.bottom < 0 || rect.top > this.height) {
          // Never keep a drinking gesture floating where an image used to be.
          this.depart();
          this.frame=requestAnimationFrame(next=>this.tick(next));
          return;
        }
      }
      const position = this.positionFor(stage, progress, sequence.variant);
      const distance = this.lastPoint
        ? Math.hypot(position.x - this.lastPoint.x, position.y - this.lastPoint.y)
        : 0;

      if (stage.pose === 'run') {
        // The stride tracks travel distance; slower movement visibly slows the legs.
        this.gait += Math.max(distance / Math.max(20, this.size * .42), delta * .00045 * this.settings.speed) * TAU;
        const ahead = this.positionFor(stage, Math.min(1, progress + .025), sequence.variant, true);
        const dx = ahead.x - position.x;
        const dy = ahead.y - position.y;
        // At near-vertical parts of the route, hold the current direction.
        // This prevents left/right jitter at the top and bottom of a loop.
        if (Math.abs(dx) > .8 && Math.abs(dx) > Math.abs(dy) * .12) {
          this.direction = dx > 0 ? 1 : -1;
        }
        this.travelTilt = clamp(Math.atan2(dy, Math.abs(dx) + 1) * 180 / Math.PI, -55, 55);
      } else {
        this.travelTilt = 0;
        // Keep the arrival direction while settling into a pose.
        // Do not mirror the drawing just because travel has stopped.
      }

      if(stage.face) this.direction=stage.face;
      this.lastPoint = position;
      this.lastRenderedPosition = position;
      this.facing.style.transform = `rotate(${(this.travelTilt || 0)*this.direction}deg) scaleX(${this.direction})`;
      this.renderRig(stage, progress, time);
      this.renderActor(stage, progress, position);
      this.renderHole(stage, progress, position, time);
      this.renderWater(stage, progress, position);
      this.renderSun(stage, time);

      if (this.settings.autoColor && (sequence.index !== this.colorStage || time - this.colorTime > 300)) {
        this.setColor(position);
        this.colorStage = sequence.index;
        this.colorTime = time;
      }

      if (this.settings.debug) {
        this.debug.textContent = `${sequence.event.type} · ${stage.name} · ${Math.round(this.settings.speed * 100)}% · ${this.landmarks.length} triggers`;
      }

      this.frame = requestAnimationFrame(next => this.tick(next));
    }

    positionFor(stage, progress, variant, preview=false) {
      if(stage.exitDown) {
        const origin=stage.exitOrigin || this.keepInside(this.lastRenderedPosition || this.lastPoint || stage.from);
        if(!preview) stage.exitOrigin=origin;
        return interpolate(origin,point(clamp(stage.to.x,this.safe.left,this.safe.right),this.height+this.size),smooth(progress));
      }
      let target;
      if(stage.waterAnchor && this.sequence.media) target=this.waterPoint(this.sequence.media);
      else if(stage.approachWater && this.sequence.media) target=interpolate(this.imagePoint(this.sequence.media),this.waterPoint(this.sequence.media),smooth(progress));
      else if(stage.residentAnchor && this.activeScene) target=this.sceneSpot(this.activeScene);
      else target=this.positionForBase(stage,progress,variant);
      target=this.keepInside(target);
      // Drinking follows the image exactly so mouth, bowl and blue drops agree.
      // Only quiet standing anchors ease their correction, independent of FPS.
      if(!preview && this.lastRenderedPosition && !stage.waterAnchor && !stage.approachWater &&
         (stage.imageAnchor || stage.residentAnchor)) {
        const amount=1-Math.exp(-Math.max(1,this.frameDelta||16)/55);
        target=interpolate(this.lastRenderedPosition,target,amount);
      }
      return target;
    }

    positionForBase(stage, progress, variant) {
      if(stage.zigzag) {
        const route=[
          stage.from,
          point(this.safe.left+this.width*.15,this.height*.38),
          point(this.safe.right,this.height*.53),
          point(this.safe.left+this.width*.12,this.height*.69),
          point(this.safe.right,this.safe.bottom)
        ];
        const segment=Math.min(3,Math.floor(progress*4));
        return interpolate(route[segment],route[segment+1],smooth(progress*4-segment));
      }
      if(stage.imageAnchor && this.sequence.media) {
        return this.imagePoint(this.sequence.media);
      }
      if(stage.approachImage && this.sequence.media) {
        return interpolate(stage.from, this.imagePoint(this.sequence.media), smooth(progress));
      }
      if(stage.leaveImage && this.sequence.media) {
        return interpolate(this.imagePoint(this.sequence.media), stage.to, smooth(progress));
      }
      if (stage.loop) {
        return this.loopPoint(smooth(progress), variant);
      }
      if (stage.circle) {
        const angle = progress * TAU;
        const radius = this.mobile ? 19 : 32;
        return point(
          stage.from.x - radius + Math.cos(angle) * radius,
          stage.from.y + Math.sin(angle) * radius * .4
        );
      }
      const t = smooth(progress);
      const a = stage.from;
      const d = stage.to;
      if (Math.hypot(d.x - a.x, d.y - a.y) < 1) {
        return a;
      }
      return bezier(
        a,
        point(mix(a.x, d.x, .32), a.y),
        point(mix(a.x, d.x, .72), d.y),
        d,
        t
      );
    }

    renderActor(stage, progress, position) {
      if(this.caption) {
        const kind=stage.pose==='sniff'?'sniff':stage.pose==='bark'?'bark':null;
        this.caption.classList.toggle('is-sniff',kind==='sniff');
        const captionWidth=kind==='bark'?(this.mobile?70:88):(this.mobile?95:115);
        this.caption.style.width=captionWidth+'px';
        const captionLeft=this.direction===1?this.size*.92:-captionWidth+this.size*.08;
        this.caption.style.left=clamp(captionLeft,12-position.x,this.width-12-captionWidth-position.x)+'px';
        this.caption.style.top=(kind==='bark'?-this.size*.12:this.size*.05)+'px';
        this.caption.style.transform='none';

        this.caption.style.opacity=kind?String(Math.min(1,progress*10,(1-progress)*8)):'0';
        this.caption.querySelectorAll('[data-caption]').forEach(art=>{
          const active=art.dataset.caption===kind;
          art.style.display=active?'block':'none';
          if(!active)return;
          art.querySelectorAll('[data-caption-word]').forEach((word,index)=>{
            const reveal=clamp((progress-index*.24)/.30,0,1);
            word.style.opacity=String(reveal>0?1:0);
            const pop=kind==='bark'?1+Math.sin(reveal*Math.PI)*.16:1;
            word.style.transform=`scale(${pop}) rotate(${kind==='bark'?(index?3:-3):0}deg)`;
            word.querySelectorAll('path').forEach((path,j)=>{
              const draw=clamp(reveal*1.5-j*.08,0,1);
              path.style.strokeDasharray='55';
              path.style.strokeDashoffset=String(55*(1-draw));
            });
          });
        });
      }
      let scale = 1;
      let opacity = stage.fadeIn ? smooth(progress) : 1;
      let diveX = 0;
      this.actor.style.transformOrigin = stage.pose==='dive' ? '50% 50%' : '50% 70%';
      this.actorClip.style.clipPath = 'none';
      let jump = 0;
      let rotation = 0;

      if(stage.pose==='startle') jump=-Math.sin(progress*Math.PI)*this.size*.08;
      if (stage.pose === 'hop' || stage.pose === 'pounce') {
        jump = -Math.sin(progress * Math.PI) * this.size * .25;
      }
      if(stage.pose === 'backflip') {
        jump=-Math.sin(progress*Math.PI)*this.size*.65;
        rotation=-360*smooth(progress);
      }
      if (stage.pose === 'dive') {
        const tip = smooth(clamp(progress / .36, 0, 1));
        const plunge = smooth(clamp((progress - .24) / .76, 0, 1));
        rotation = 90 * tip;
        diveX = -this.size * .034 * tip;
        jump = this.size * .80 * plunge;
        // Clip the full-size dog at the ground, rather than scaling/fading him.
        // The nose crosses first, followed by shoulders, body, paws and tail.
        const groundY = position.y + this.size * .65 + 14;
        const bottomInset = Math.max(0, this.height - groundY);
        this.actorClip.style.clipPath = `inset(0px 0px ${bottomInset}px 0px)`;
      }
      if (stage.pose === 'hidden') {
        scale = 0;
        opacity = 0;
      }

      this.actor.style.transform = `translate3d(${position.x + diveX}px, ${position.y + jump}px, 0) rotate(${rotation}deg) scale(${scale})`;
      this.actor.style.opacity = String(opacity);
      this.poof.style.opacity = '0';
      if (stage.poof) {
        const elapsed = progress * stage.duration;
        const appear = smooth(clamp((elapsed-100)/150,0,1));
        const clear = smooth(clamp((elapsed-1100)/500,0,1));
        const frame = Math.floor(elapsed/150)%this.cloudFrames.length;
        this.cloudFrames.forEach((art,index)=>art.style.display=index===frame?'block':'none');
        this.poof.style.opacity = String(appear*(1-clear));
        // Three redrawn silhouettes flicker gently like a drawn dust cloud.
        // The words stay fixed; no rotation, sideways swing or shrinking.
        this.poof.style.transform = `scale(${.98+(frame===1?.02:frame===2?.01:0)})`;
        this.label.style.opacity = String(1-smooth(clamp(elapsed/180,0,1)));
        this.label.style.transform = 'none';
      } else {
        this.label.style.opacity = stage.label ? '1' : stage.draw ? String(1-progress) : '0';
      }
      if (stage.label) {
        this.label.style.top=this.sequence.event.type==='intro'?'32%':'-45%';
        const labelWidth=this.labelNaturalWidth;
        const labelLeft=clamp(position.x+(this.size-labelWidth)/2,12,Math.max(12,this.width-labelWidth-12));
        this.label.style.right=`${position.x+this.size-labelLeft-labelWidth}px`;
        // Draw each real SVG stroke, then keep the finished handwriting alive
        // with a low-amplitude breathing pulse. No typed font or hard flashing.
        const elapsed = progress * stage.duration;
        const pulse = elapsed > 1400 ? Math.sin((elapsed - 1400) / 1500 * TAU) : 0;
        const arrive = mix(.97, 1, smooth(clamp(elapsed / 450, 0, 1)));
        this.label.style.transform = `scale(${arrive + pulse * .008})`;
        this.labelPaths.forEach(({path, length}, index) => {
          const draw = smooth(clamp((elapsed - index * 95) / 520, 0, 1));
          path.style.strokeDasharray = `${length} ${length}`;
          path.style.strokeDashoffset = String(length * (1 - draw));
          path.style.opacity = String(draw > 0 ? .91 + pulse * .09 : 0);
          path.style.strokeWidth = String(1.7 + pulse * .07);
        });
      } else if (!stage.poof) {
        this.label.style.transform = stage.draw ? `scale(${1 - progress * .08})` : 'none';
      }
      this.dog.style.opacity = stage.label && this.sequence.event.type==='intro' ? '0' : stage.poof ? String(smooth(clamp((progress-.69)/.18,0,1))) : stage.draw ? String(progress) : '1';

      if (stage.draw && !stage.poof) {
        this.drawPaths.forEach(path => {
          path.style.strokeDasharray = '360';
          const ink=stage.poof?smooth(clamp((progress-.40)/.55,0,1)):progress;
          path.style.strokeDashoffset = String(360 * (1 - ink));
        });
      } else {
        this.drawPaths.forEach(path => {
          path.style.strokeDasharray = '';
          path.style.strokeDashoffset = '';
        });
      }
    }

    renderRig(stage, progress, clock) {
      const seconds = clock / 1000;
      const running = stage.pose === 'run';
      const sit = stage.pose === 'sit' ? 1 : stage.pose === 'sit-down'
        ? smooth(progress)
        : stage.pose === 'rise'
          ? 1 - smooth(progress)
          : stage.seated ? 1 : 0;
      const breathing = Math.sin(seconds * 2.5) * .6;
      const bounce = running ? Math.sin(this.gait * 2) * 2.3 : breathing;
      const crouch = stage.pose === 'dig' ? 5 : stage.pose === 'bow' ? 4 : sit * 7;
      const bodyAngle = stage.pose === 'dig' ? 9 : stage.pose === 'bow' ? 13 : stage.pose==='shake'?Math.sin(seconds*24*this.settings.speed)*5:-sit * 13;

      const stretch=stage.pose==='stretch'?Math.sin(progress*Math.PI)*.09:0;
      this.rig.setAttribute('transform', `translate(0 ${bounce+crouch-stretch*90}) rotate(${bodyAngle} 98 82) scale(1 ${1+stretch})`);

      let headAngle = 0;
      if (stage.pose === 'look') {
        headAngle = Math.sin(progress * Math.PI) * -11;
      }
      if(stage.pose==='startle') headAngle=-14*Math.sin(progress*Math.PI);
      if(stage.pose==='pant') headAngle=8+Math.sin(seconds*5)*2;
      if(stage.pose==='nose-dip') headAngle=23*smooth(progress);
      if(stage.pose==='lip-lick') headAngle=8+Math.sin(progress*Math.PI)*5;
      if (stage.pose === 'sniff') {
        headAngle = 16 + Math.sin(seconds * 7) * 3;
      }
      if(stage.pose==='look-up' || stage.pose==='stretch') headAngle=-18;
      if(stage.pose==='shake') headAngle=Math.sin(seconds*25*this.settings.speed)*14;
      if(stage.pose==='bark') headAngle=-8+Math.sin(progress*Math.PI*4)*4;
      if (stage.pose === 'sip') {
        headAngle=23+Math.sin(progress*Math.PI*6)*3;
      }
      if(stage.pose === 'look-back') {
        headAngle=-19*Math.sin(progress*Math.PI);
      }
      if (stage.pose === 'rest') {
        headAngle = 7;
      }
      if (stage.pose === 'scratch') {
        headAngle = -8;
      }
      if (stage.pose === 'peer') headAngle = 22 * Math.sin(progress * Math.PI);
      if (stage.pose === 'dig') {
        headAngle = 12 + Math.sin(seconds * 16 * this.settings.speed) * 3;
      }

      this.head.setAttribute('transform', `rotate(${headAngle} 127 57)`);
      if(this.tongue) {
        const lap=Math.max(0,Math.sin(progress*Math.PI*6));
        this.tongue.style.opacity=stage.pose==='pant'?'1':stage.pose==='sip'?String(lap):stage.pose==='lip-lick'?String(Math.sin(progress*Math.PI)):'0';
        this.tongue.setAttribute('d',stage.pose==='lip-lick'?'M162 53Q174 52 171 45Q167 42 165 49':`M162 53Q164 ${58+lap*5} 167 56`);
      }
      const earAngle = running ? Math.sin(this.gait + .7) * 7 : Math.sin(seconds * 2) * 2;
      this.ear.setAttribute('transform', `rotate(${earAngle} 125 29)`);
      const wagRate = stage.pose === 'wag' ? 10 : running ? 6 : 3;
      const wagSize = stage.pose === 'wag' ? 17 : running ? 10 : 5;
      this.tail.setAttribute('transform', `rotate(${Math.sin(seconds * wagRate * this.settings.speed) * wagSize} 44 65)`);

      const hips = {
        'back-far': point(63, 78),
        'front-far': point(108, 77),
        'back-near': point(54, 79),
        'front-near': point(117, 77)
      };

      Object.entries(hips).forEach(([name, hip]) => {
        const front = name.startsWith('front');
        const far = name.endsWith('far');
        let foot = point(hip.x + (front ? 4 : -8), 113 - sit * 5);
        const phase = this.gait + ((front !== far) ? Math.PI : 0);

        if (running) {
          // Diagonal pairs alternate contact and lift, giving a readable trot.
          const cycle = ((phase / TAU) % 1 + 1) % 1;
          if (cycle < .58) {
            // A planted paw moves backward relative to the body as it advances.
            foot = point(hip.x + mix(12, -12, cycle / .58), 112);
          } else {
            // Then the paw lifts and reaches forward for the next contact.
            const swing = (cycle - .58) / .42;
            foot = point(hip.x + mix(-12, 12, smooth(swing)), 112 - Math.sin(swing * Math.PI) * 11);
          }
        } else if (sit > 0) {
          foot.x = mix(foot.x, front ? hip.x + 8 : hip.x - 23, sit);
        }

        if (stage.pose === 'scratch' && name === 'back-near') {
          const reach = smooth(clamp(progress/.2,0,1)) * (1-smooth(clamp((progress-.8)/.2,0,1)));
          foot = point(mix(hip.x-23,117,reach) + Math.sin(progress*Math.PI*4)*3*reach, mix(108,54,reach));
          // Stretching is confined to this stylized gesture, not the running gait.
          this.legs[name].setAttribute('d', limb(hip, foot, 40, 40, -1));
          return;
        }

        if (stage.pose === 'dig' && front) {
          const scratchPhase = seconds * 18 * this.settings.speed + (far ? Math.PI : 0);
          foot = point(hip.x + 12 + Math.cos(scratchPhase) * 10, 107 - Math.max(0, Math.sin(scratchPhase)) * 13);
        }

        if(stage.pose === 'bow' && front) {
          foot.x+=8;
          foot.y-=6;
        }

        if (stage.pose === 'hop' || stage.pose === 'pounce' || stage.pose === 'dive' || stage.pose === 'backflip') {
          const tuck = Math.sin(progress * Math.PI);
          foot.y -= tuck * 13;
          foot.x += (front ? -1 : 1) * tuck * 9;
        }

        this.legs[name].setAttribute('d', limb(hip, foot, 21, 23, front ? 1 : -1));
      });
    }

    renderSun(stage,time) {
      if(this.sequence.event.type!=='heat' || !this.sequence.media || stage.exitDown) {
        this.sun.style.opacity='0';return;
      }
      const anchor=this.imagePoint(this.sequence.media);
      const width=this.mobile?54:74;
      const x=clamp(anchor.x-this.size*.12,8,this.width-width-8);
      const y=clamp(anchor.y-width*.95,this.safe.top,this.safe.bottom);
      this.sun.style.width=`${width}px`;
      this.sun.style.transform=`translate3d(${x}px,${y}px,0)`;
      this.sun.style.opacity='.95';
      const rays=time*TAU/450,waves=time*TAU/360;
      this.sunRays.setAttribute('transform',`translate(50 50) rotate(${Math.sin(rays)*6}) scale(${1+Math.sin(rays)*.06}) translate(-50 -50)`);
      this.heatWaves.style.opacity=String(.78+.12*Math.sin(waves));
      this.heatWaves.setAttribute('transform',`translate(0 ${-2.5*(1+Math.sin(waves))})`);
    }

    renderWater(stage,progress,position) {
      if(stage.pose!=='sip' || !this.sequence.media) {
        this.water.style.opacity='0';
        return;
      }
      const factor=this.mobile ? 0.75 : 1;
      const x=position.x+this.size*.97;
      const y=position.y+this.size*.43;
      this.water.style.transformOrigin='0 0';
      this.water.style.transform=`translate3d(${x-50*factor}px,${y-44*factor}px,0) scale(${factor})`;
      this.water.style.opacity=String(Math.min(1,progress*12,(1-progress)*12));
      const elapsed=progress*stage.duration;
      this.water.querySelectorAll('[data-water-ring]').forEach((ring,index)=>{
        const phase=(elapsed/320+index/3)%1;
        ring.setAttribute('rx',String(8+phase*25));
        ring.setAttribute('ry',String(2.5+phase*6));
        ring.style.opacity=String((1-phase)*.8);
      });
      this.water.querySelectorAll('[data-water-drop]').forEach((drop,index)=>{
        const phase=(elapsed/240+index*.27)%1;
        const lift=Math.sin(phase*Math.PI);
        drop.setAttribute('transform',`translate(${50+(index-1)*(7+phase*8)} ${41-lift*(12+index*3)})`);
        drop.style.opacity=String(lift*.75);
      });
    }

    renderHole(stage, progress, position, clock) {
      const finale = this.sequence.event.type === 'finale';
      if (!finale) {
        this.hole.style.opacity = '0';
        this.dirt.style.opacity = '0';
        return;
      }

      const digging = stage.pose === 'dig';
      const leaving = stage.pose === 'dive';
      const peering = stage.pose === 'peer';
      const closed = stage.pose === 'hidden';
      const holeWidth = this.mobile ? 46 : 64;
      this.hole.style.width = `${holeWidth}px`;
      this.hole.style.left = `${position.x + this.size * .56 - holeWidth / 2}px`;
      this.hole.style.top = `${position.y + this.size * .65}px`;
      this.hole.style.opacity = digging || peering || leaving ? '.8' : closed ? String(.8 * (1 - progress)) : '0';
      const size = digging ? smooth(progress) : closed ? 1 - smooth(progress) : 1;
      this.hole.style.transform = `scale(${size})`;
      this.dirt.style.opacity = digging ? '.7' : '0';

      if (digging) {
        this.particles.forEach((particle, index) => {
          const t = ((clock * .0018 * this.settings.speed + index * .2) % 1);
          particle.setAttribute('cx', String(65 - t * (40 + index * 5)));
          particle.setAttribute('cy', String(70 - Math.sin(t * Math.PI) * (28 + index * 4)));
          particle.style.opacity = String(Math.sin(t * Math.PI));
        });
      }
    }

    setColor(position) {
      // The brand sketch stays lime (or the chosen dog color) on every section.
      // Older saved automatic-color settings are deliberately ignored.
      this.style.setProperty('--cc-dog-color', this.settings.color);
    }

    complete() {
      if(this.sequence) this.played.set(this.sequence.event.target,{time:performance.now(),left:false});
      this.cancel();
      this.sceneDirty=true;
    }

    cancel() {
      cancelAnimationFrame(this.frame);
      this.frame = null;
      this.sequence = null;
      this.pending = null;
      this.lastPoint = null;
      this.actor.style.opacity = '0';
      this.hole.style.opacity = '0';
      this.dirt.style.opacity = '0';
      this.label.style.opacity = '0';
      this.poof.style.opacity = '0';
      this.water.style.opacity = '0';
      this.sun.style.opacity = '0';
      this.actorClip.style.clipPath = 'none';
      if(this.caption) this.caption.style.opacity='0';
      if (this.settings?.debug) {
        this.debug.textContent = 'Waiting for the next section';
      }
    }

    disconnectedCallback() {
      this.connected = false;
      cancelAnimationFrame(this.sceneFrame);
      this.scenes?.forEach(scene=>scene.node?.remove());
      clearTimeout(this.timer);
      clearTimeout(this.resizeTimer);
      clearTimeout(this.refreshTimer);
      clearTimeout(this.initialTimer);
      clearTimeout(this.triggerTimer);
      cancelAnimationFrame(this.scrollFrame);
      this.observer?.disconnect();
      this.layoutObserver?.disconnect();
      this.abort?.abort();
      if (this.actor) {
        this.cancel();
      }
    }
  }

  customElements.define('cc-follow-dog', FollowDog);
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty(
        '--header-height',
        `${this.header.offsetHeight}px`
      );
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (
        [...this.predictiveSearches].some(
          (predictiveSearch) => predictiveSearch.isOpen
        )
      ) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (
        scrollTop < this.currentScrollTop &&
        scrollTop > this.headerBounds.bottom
      ) {
        this.header.classList.add('scrolled-past-header');

        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;

      this.header.classList.add(
        'shopify-section-header-hidden',
        'shopify-section-header-sticky'
      );

      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;

      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;

      this.header.classList.remove(
        'shopify-section-header-hidden',
        'shopify-section-header-sticky',
        'animate'
      );
    }

    closeMenuDisclosure() {
      this.disclosures =
        this.disclosures || this.header.querySelectorAll('header-menu');

      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals =
        this.searchModals || this.header.querySelectorAll('details-modal');

      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  document.addEventListener(
    'open',
    (event) => {
      if (
        !(event.target instanceof HTMLElement) ||
        !event.target.matches('shopify-account')
      ) return;

      const bottom = Math.max(
        0,
        Math.round(event.target.getBoundingClientRect().bottom)
      );

      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
